/**
 * Décode une polyline encodée (format utilisé par VROOM/Google Maps)
 * Retourne un tableau de coordonnées [lat, lng]
 * 
 * @param {string} encoded - Chaîne polyline encodée
 * @param {boolean} is5Bit - Si true, utilise une précision de 5 bits (format VROOM)
 * @returns {Array<[number, number]>} Tableau de coordonnées [lat, lng]
 */
export function decodePolyline(encoded, is5Bit = false) {
  if (!encoded) return [];

  const points = [];
  let index = 0;
  const len = encoded.length;
  let lat = 0;
  let lng = 0;
  const factor = is5Bit ? 1e5 : 1e6;

  while (index < len) {
    let b;
    let shift = 0;
    let result = 0;

    do {
      b = encoded.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);

    const dlat = result & 1 ? ~(result >> 1) : result >> 1;
    lat += dlat;

    shift = 0;
    result = 0;

    do {
      b = encoded.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);

    const dlng = result & 1 ? ~(result >> 1) : result >> 1;
    lng += dlng;

    points.push([lat / factor, lng / factor]);
  }

  return points;
}

/**
 * Décode une géométrie VROOM
 * VROOM utilise le format polyline avec précision de 5 bits
 * Les coordonnées sont retournées au format [lat, lng] pour Leaflet
 * 
 * @param {string} geometry - Géométrie encodée de VROOM
 * @returns {Array<[number, number]>} Tableau de coordonnées [lat, lng]
 */
export function decodeVroomGeometry(geometry) {
  return decodePolyline(geometry, true);
}


